import React from "react";

import { OriginThemeProvider } from "@origin-digital/ods-core";

import { App } from "./components/App";

export default () => (
  <OriginThemeProvider enableThemeSwitching>
    <App />
  </OriginThemeProvider>
);
